window.OURO_CATALOG = [
  {
    "key": "10",
    "family": "seda-uva",
    "name": "OURO Uva Seda Capilar 150 ml",
    "presentation": "150 ml",
    "handle": "ouro-uva-seda-capilar-125ml",
    "productId": "9547740086460",
    "price": 13654,
    "photo": "ouro-lab-seda-uva-150ml.webp"
  },
  {
    "key": "11",
    "family": "seda-uva",
    "name": "OURO Uva Seda Capilar 75 ml",
    "presentation": "75 ml",
    "handle": "ouro-uva-seda-capilar-75ml",
    "productId": "9547740119228",
    "price": 8606,
    "photo": "ouro-uva-75ml.webp"
  },
  {
    "key": "12",
    "family": "seda-uva",
    "name": "OURO Uva Seda Capilar 20 ml",
    "presentation": "20 ml",
    "handle": "ouro-uva-seda-capilar-20ml",
    "productId": "9609970778300",
    "price": 3677,
    "photo": "ouro-uva-20ml.webp"
  },
  {
    "key": "13",
    "family": "seda-lino",
    "name": "OURO Seda de Lino 65 ml",
    "presentation": "65 ml",
    "handle": "ouro-seda-de-lino-65ml",
    "productId": "9547740151996",
    "price": 13654,
    "photo": "ouro-lab-seda-lino-65ml.webp"
  },
  {
    "key": "14",
    "family": "seda-lino",
    "name": "OURO Seda de Lino 20 ml",
    "presentation": "20 ml",
    "handle": "ouro-seda-de-lino-20ml",
    "productId": "9609970843836",
    "price": 3677,
    "photo": "ouro-lino-20ml.webp"
  },
  {
    "key": "15",
    "family": "seda-aloe",
    "name": "OURO Aloe Seda Capilar 150 ml",
    "presentation": "150 ml",
    "handle": "ouro-aloe-seda-capilar-125ml",
    "productId": "9547740283068",
    "price": 13654,
    "photo": "ouro-lab-seda-aloe-150ml.webp"
  },
  {
    "key": "16",
    "family": "seda-aloe",
    "name": "OURO Aloe Seda Capilar 75 ml",
    "presentation": "75 ml",
    "handle": "ouro-aloe-seda-capilar-75ml",
    "productId": "9547740315836",
    "price": 8606,
    "photo": "ouro-aloe-75ml.webp"
  },
  {
    "key": "17",
    "family": "seda-aloe",
    "name": "OURO Aloe Seda Capilar 20 ml",
    "presentation": "20 ml",
    "handle": "ouro-aloe-seda-capilar-20ml",
    "productId": "9609970909372",
    "price": 3677,
    "photo": "ouro-aloe-20ml.png"
  },
  {
    "key": "18",
    "family": null,
    "name": "OURO Purify Shampoo 250 ml",
    "presentation": "250 ml",
    "handle": "ouro-shampoo-purifying-250ml",
    "productId": "9547740348604",
    "price": 11010,
    "photo": "ouro-purify-250ml.webp"
  },
  {
    "key": "19",
    "family": "mat-platinado",
    "name": "OURO Shampoo Matizador Rubio y Platinado 300 ml",
    "presentation": "300 ml",
    "handle": "ouro-shampoo-matizador-plata-250ml",
    "productId": "9547740381372",
    "price": 11010,
    "photo": "ouro-lab-matizador-platinado-300ml.webp"
  },
  {
    "key": "20",
    "family": "mat-rojo",
    "name": "OURO Shampoo Matizador Rojo 300 ml",
    "presentation": "300 ml",
    "handle": "ouro-shampoo-matizador-rojo-250ml",
    "productId": "9547740414140",
    "price": 11010,
    "photo": "ouro-lab-matizador-rojo-300ml.webp"
  },
  {
    "key": "21",
    "family": "mat-negro",
    "name": "OURO Shampoo Matizador Negro 300 ml",
    "presentation": "300 ml",
    "handle": "ouro-shampoo-matizador-negro-300ml",
    "productId": "9547740446908",
    "price": 11010,
    "photo": "ouro-lab-matizador-negro-300ml.webp"
  },
  {
    "key": "22",
    "family": "mat-platinado",
    "name": "OURO Shampoo Matizador Rubio y Platinado 900 ml (bolsa)",
    "presentation": "900 ml (bolsa)",
    "handle": "ouro-shampoo-matizador-plata-900ml",
    "productId": "9547740676284",
    "price": 17982,
    "photo": "ouro-matizador-rubio-900ml.webp"
  },
  {
    "key": "23",
    "family": "mat-platinado",
    "name": "OURO Shampoo Matizador Rubio y Platinado 1 L",
    "presentation": "1 litro",
    "handle": "ouro-shampoo-matizador-plata-1l",
    "productId": "9547741102268",
    "price": 20867,
    "photo": "ouro-matizador-rubio-1l.webp"
  },
  {
    "key": "24",
    "family": "mat-negro",
    "name": "OURO Shampoo Matizador Negro 1 L",
    "presentation": "1 litro",
    "handle": "ouro-shampoo-matizador-negro-1l",
    "productId": "9547741200572",
    "price": 20867,
    "photo": "ouro-matizador-negro-1l.webp"
  },
  {
    "key": "25",
    "family": "argan",
    "name": "OURO Argán Tratamiento Capilar 125 ml",
    "presentation": "125 ml",
    "handle": "ouro-argan-tratamiento-capilar-125ml",
    "productId": "9547741233340",
    "price": 15578,
    "photo": "ouro-lab-argan-125ml.webp"
  },
  {
    "key": "26",
    "family": "extrarepair",
    "name": "OURO Extra Repair 250 ml",
    "presentation": "250 ml",
    "handle": "ouro-extra-repair-250ml",
    "productId": "9547741397180",
    "price": 16660,
    "photo": "ouro-lab-extra-repair-250ml.webp"
  },
  {
    "key": "27",
    "family": "dailycare",
    "name": "OURO Daily Care Nutrition Therapy 240 ml",
    "presentation": "240 ml",
    "handle": "ouro-daily-care-240ml",
    "productId": "9547741495484",
    "price": 15578,
    "photo": "ouro-lab-daily-care-240ml.webp"
  },
  {
    "key": "28",
    "family": "ultrahold",
    "name": "OURO Ultra Hold Spray Fijador 250 ml",
    "presentation": "250 ml",
    "handle": "ouro-ultra-hold-spray-250ml",
    "productId": "9547741593788",
    "price": 10769,
    "photo": "ouro-lab-ultra-hold-250ml.webp"
  },
  {
    "key": "29",
    "family": "curl",
    "name": "OURO Bio-Curl Crema para Rizos 250 ml",
    "presentation": "250 ml",
    "handle": "ouro-bio-curl-250ml",
    "productId": "9547741757628",
    "price": 14616,
    "photo": "ouro-lab-bio-curl-250ml.webp"
  },
  {
    "key": "30",
    "family": null,
    "name": "OURO Slim-Aid Gel Reductor 250 g",
    "presentation": "250 g",
    "handle": "ouro-slim-aid-gel-reductor-250g",
    "productId": "9547741855932",
    "price": 6442,
    "photo": "ouro-slim-aid-250g.webp"
  },
  {
    "key": "31",
    "family": "bifasico",
    "name": "OURO Biphasic Therapy Hair System 240 ml",
    "presentation": "240 ml",
    "handle": "ouro-biphasic-240ml",
    "productId": "9547741888700",
    "price": 10890,
    "photo": "ouro-lab-bifasico-240ml.webp"
  },
  {
    "key": "32",
    "family": "bioshield",
    "name": "OURO Bio-Shield Protector de Color 125 ml",
    "presentation": "125 ml",
    "handle": "ouro-bio-shield-125ml",
    "productId": "9547742085308",
    "price": 15938,
    "photo": "ouro-lab-bioshield-125ml.webp"
  },
  {
    "key": "33",
    "family": null,
    "name": "OURO Glow Sílica Frutos Rojos 125 ml",
    "presentation": "125 ml",
    "handle": "ouro-glow-silica-frutos-rojos-125ml",
    "productId": "9609971204284",
    "price": 9808,
    "photo": "ouro-glow-frutos-125ml.webp"
  },
  {
    "key": "34",
    "family": null,
    "name": "OURO Glow Sílica Argán 125 ml",
    "presentation": "125 ml",
    "handle": "ouro-glow-silica-argan-125ml",
    "productId": "9609971237052",
    "price": 9808,
    "photo": "ouro-glow-argan-125ml.webp"
  },
  {
    "key": "35",
    "family": null,
    "name": "OURO Serum D’Aqua 125 ml",
    "presentation": "125 ml",
    "handle": "ouro-serum-daqua-125ml",
    "productId": "9609971269820",
    "price": 6382,
    "photo": "ouro-serum-daqua-125ml.webp"
  },
  {
    "key": "36",
    "family": null,
    "name": "OURO Serum D’Aqua Shine Argán 125 ml",
    "presentation": "125 ml",
    "handle": "ouro-serum-daqua-shine-argan-125ml",
    "productId": "9609971302588",
    "price": 7608,
    "photo": "ouro-shine-daqua-125ml.webp"
  },
  {
    "key": "37",
    "family": "alpha-pomade",
    "name": "OURO Alpha 1 Pomade 85 g",
    "presentation": "85 g",
    "handle": "ouro-alpha-pomade-85g",
    "productId": "9547742183612",
    "price": 11010,
    "photo": "ouro-lab-alpha-pomade.webp"
  },
  {
    "key": "38",
    "family": "alpha-so-dark",
    "name": "OURO Alpha 3 So Dark 240 ml",
    "presentation": "240 ml",
    "handle": "ouro-alpha-so-dark-250ml",
    "productId": "9547742249148",
    "price": 11851,
    "photo": "ouro-lab-alpha-so-dark.webp"
  },
  {
    "key": "39",
    "family": "alpha-cream-gel",
    "name": "OURO Alpha 4 Cream Gel 240 ml",
    "presentation": "240 ml",
    "handle": "ouro-alpha-cream-gel-250ml",
    "productId": "9547742347452",
    "price": 11370,
    "photo": "ouro-lab-alpha-cream-gel.webp"
  },
  {
    "key": "40",
    "family": "alpha-beard-oil",
    "name": "OURO Alpha Beard Oil 30 ml",
    "presentation": "30 ml",
    "handle": "ouro-alpha-beard-oil-30ml",
    "productId": "9547742412988",
    "price": 11250,
    "photo": "ouro-lab-alpha-beard-oil.webp"
  },
  {
    "key": "41",
    "family": "kids-bifasico",
    "name": "OURO Kids Detangler 240 ml",
    "presentation": "240 ml",
    "handle": "ouro-kids-detangler-240ml",
    "productId": "9547742445756",
    "price": 10890,
    "photo": "ouro-lab-kids-bifasico.webp"
  },
  {
    "key": "42",
    "family": "kids-magic-spritz",
    "name": "OURO Kids Magic Spritz Gel 500 ml",
    "presentation": "500 ml",
    "handle": "ouro-kids-magic-spritz-500ml",
    "productId": "9547742511292",
    "price": 9447,
    "photo": "ouro-lab-kids-magic-spritz.webp"
  },
  {
    "key": "43",
    "family": null,
    "name": "OURO Capa de Nylon",
    "presentation": "1 pieza",
    "handle": "ouro-capa-de-nylon",
    "productId": "9609971466428",
    "price": 13414,
    "photo": null
  }
];

// Lista autorizada 2026-09-30: MXN, IVA incluido, sin envio.
(function () {
  const prices = {"10":150,"11":120,"12":45,"13":155,"14":45,"15":150,"16":120,"17":45,"18":100,"19":110,"20":110,"21":110,"22":200,"23":230,"24":230,"25":185,"26":185,"27":170,"28":135,"29":160,"30":80,"31":140,"32":185,"33":125,"34":125,"35":115,"36":95,"37":145,"38":160,"39":160,"40":140,"41":140,"42":120};
  window.OURO_CATALOG.forEach(function (row) {
    if (Object.prototype.hasOwnProperty.call(prices, row.key)) row.price = prices[row.key] * 100;
    if (row.productId === "9547740414140") {
      row.name = "OURO Shampoo Matizador Rojo 250 ml";
      row.presentation = "250 ml";
      row.photo = "OuroShampoo_Rojos.png"; // Foto vigente de 250 ml; independiente del laboratorio.
    }
  });
})();

// Retirada temporal 2026-10-07: la capa de nylon (clave 43) sale de la tienda hasta tener fotografía.
// El producto se conserva en Shopify con su precio, código e inventario; para restaurarla, quitar este filtro.
window.OURO_CATALOG = window.OURO_CATALOG.filter(function (row) { return row.key !== "43"; });
